import { useMemo } from 'react';
import { useTheme } from 'foundations-theming-specialty/utils';
export const useConditionalPalettes = () => {
  const theme = useTheme();
  return useMemo(() => {
    const getTrellisTokenHexValue = tokenKey => theme.color[tokenKey] || '#ffffff';
    const OrangeToWhite = {
      id: 'OrangeToWhite',
      colors: {
        minColor: getTrellisTokenHexValue('reporting-fill-chart-default-light-orange'),
        maxColor: getTrellisTokenHexValue('reporting-fill-chart-white')
      },
      label: 'reporting-visualizations.conditional-formatting-palette.orange-to-white'
    };
    const WhiteToOrange = {
      id: 'WhiteToOrange',
      colors: {
        minColor: getTrellisTokenHexValue('reporting-fill-chart-white'),
        maxColor: getTrellisTokenHexValue('reporting-fill-chart-default-light-orange')
      },
      label: 'reporting-visualizations.conditional-formatting-palette.white-to-orange'
    };
    const AquaToWhite = {
      id: 'AquaToWhite',
      colors: {
        minColor: getTrellisTokenHexValue('reporting-fill-chart-default-light-aqua'),
        maxColor: getTrellisTokenHexValue('reporting-fill-chart-white')
      },
      label: 'reporting-visualizations.conditional-formatting-palette.aqua-to-white'
    };
    const WhiteToAqua = {
      id: 'WhiteToAqua',
      colors: {
        minColor: getTrellisTokenHexValue('reporting-fill-chart-white'),
        maxColor: getTrellisTokenHexValue('reporting-fill-chart-default-light-aqua')
      },
      label: 'reporting-visualizations.conditional-formatting-palette.white-to-aqua'
    };
    const GreenToWhite = {
      id: 'GreenToWhite',
      colors: {
        minColor: getTrellisTokenHexValue('reporting-fill-chart-positive'),
        maxColor: getTrellisTokenHexValue('reporting-fill-chart-white')
      },
      label: 'reporting-visualizations.conditional-formatting-palette.green-to-white'
    };
    const WhiteToGreen = {
      id: 'WhiteToGreen',
      colors: {
        minColor: getTrellisTokenHexValue('reporting-fill-chart-white'),
        maxColor: getTrellisTokenHexValue('reporting-fill-chart-positive')
      },
      label: 'reporting-visualizations.conditional-formatting-palette.white-to-green'
    };
    const RedToWhite = {
      id: 'RedToWhite',
      colors: {
        minColor: getTrellisTokenHexValue('reporting-fill-chart-alert'),
        maxColor: getTrellisTokenHexValue('reporting-fill-chart-white')
      },
      label: 'reporting-visualizations.conditional-formatting-palette.red-to-white'
    };
    const WhiteToRed = {
      id: 'WhiteToRed',
      colors: {
        minColor: getTrellisTokenHexValue('reporting-fill-chart-white'),
        maxColor: getTrellisTokenHexValue('reporting-fill-chart-alert')
      },
      label: 'reporting-visualizations.conditional-formatting-palette.white-to-red'
    };
    const GreenYellowRed = {
      id: 'GreenYellowRed',
      colors: {
        minColor: getTrellisTokenHexValue('reporting-fill-chart-positive'),
        midColor: getTrellisTokenHexValue('reporting-fill-chart-caution'),
        maxColor: getTrellisTokenHexValue('reporting-fill-chart-alert')
      },
      label: 'reporting-visualizations.conditional-formatting-palette.green-yellow-red'
    };
    const RedYellowGreen = {
      id: 'RedYellowGreen',
      colors: {
        minColor: getTrellisTokenHexValue('reporting-fill-chart-alert'),
        midColor: getTrellisTokenHexValue('reporting-fill-chart-caution'),
        maxColor: getTrellisTokenHexValue('reporting-fill-chart-positive')
      },
      label: 'reporting-visualizations.conditional-formatting-palette.red-yellow-green'
    };
    return {
      OrangeToWhite,
      WhiteToOrange,
      AquaToWhite,
      WhiteToAqua,
      GreenToWhite,
      WhiteToGreen,
      RedToWhite,
      WhiteToRed,
      GreenYellowRed,
      RedYellowGreen
    };
  }, [theme]);
};